/**
 * Only a real auth rejection (401 / UNAUTHORIZED) ends the session. A network
 * failure or a 5xx means the API is unreachable, so the stored token is kept.
 */
export function shouldSignOutOnSessionError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const { status, code } = error as { status?: unknown; code?: unknown };
  return status === 401 || code === "UNAUTHORIZED";
}

/**
 * What a failed GET /me does to the session: a 401 signs out; otherwise the
 * token is kept and the cached user is used, or, with none cached, the app
 * shows "Can't reach the server" (routing to /signin would drop a valid session).
 */
export function sessionErrorOutcome(error: unknown, hasCachedUser: boolean): "sign_out" | "use_cached" | "unreachable" {
  if (shouldSignOutOnSessionError(error)) return "sign_out";
  return hasCachedUser ? "use_cached" : "unreachable";
}
